module.exports = __webpack_public_path__ + "img/logo-social-share.a55f2f05.png";